import api from './axios';

export const fetchSalonsForStaffRegistration = (params) =>
  api.get('/auth/register-staff/salons', { params }).then((r) => r.data);

export const registerStaff = (body) => api.post('/auth/register-staff', body).then((r) => r.data);
